import type { PolicyLevel } from '../types';

/** 与园区 buildStableParkId 一致：折叠空白，避免键漂移 */
export function normalizeIdPart(raw: unknown): string {
  return String(raw ?? '').trim().replace(/\s+/g, ' ');
}

/**
 * 由层级 + 行政区生成稳定政策 ID，与 policies.json 数组顺序无关。
 *
 * 示例：
 * - national:
 * - provincial:广东省
 * - city:广东省|广州市
 * - park:山西省|山西大同经济技术开发区
 */
export function buildStablePolicyId(
  level: PolicyLevel,
  province: string,
  city: string,
  parkName = '',
): string {
  const p = normalizeIdPart(province);
  const c = normalizeIdPart(city);
  const park = normalizeIdPart(parkName);
  if (level === 'national') return 'national:';
  if (level === 'provincial') return `provincial:${p}`;
  if (level === 'park') return `park:${p}|${park}`;
  return `city:${p}|${c}`;
}
